
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/undervisningsopplegg/[slug]",
      function () {
        return require("private-next-pages/undervisningsopplegg/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/undervisningsopplegg/[slug]"])
      });
    }
  